<template>
    <v-container>
        <v-row>
            <v-col>
                <h4 class="text-h4">Item Groups</h4>
                <p class="text-subtitle-1">Manage Item Groups/Subgroups</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn block color="primary" @click="handleNew" v-if="hasPermission(perm.item_group.create)">
                    <v-icon left>mdi-plus</v-icon>
                    add root group
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn block depressed @click="search">
                    <v-icon left>mdi-refresh</v-icon>
                    refresh
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <ItemGroupList/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions'
import ItemGroupList from './../../components/warehouse/ItemGroupList.vue'
import { mapActions, mapGetters } from 'vuex';
export default {
    name: "ItemGroupListView",
    components: {
        ItemGroupList
    },
    data() {
        return {
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        handleNew() {
            this.$router.push({ name: "ItemGroupCreate" })
        },
        ...mapActions({
            search: "stock/itemGroup/list/search"
        }),
    }
}
</script>

<style>
</style>